module.exports = __webpack_public_path__ + "media/credit-calculator.2f7c47c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/credit/credit-calculator.png
// module id = 754
// module chunks = 2